import { Component } from '@angular/core';
import { AppService } from '../app.service';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { MatDialog } from '@angular/material/dialog';
import { AbsenceDetailModalComponent } from './absence-detail-modal/absence-detail-modal.component';
import { BusService } from '../Bus.service';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';



@Component({
  selector: 'app-student-detail',
  templateUrl: './student-detail.component.html',
  styleUrls: ['./student-detail.component.css']
})
export class StudentDetailComponent {
  students:any;
  Location:any={lId:107, description:""} ;
  AbsDetail:any;
  filter:any = "";
  loading:boolean = false;

  faInfoCircle = faInfoCircle;



  constructor(
		private authService: MsalService,
		private msalBroadcastService: MsalBroadcastService,
		private srv: AppService,
    public dialog: MatDialog,
    public comm: BusService
	) {

  }

	ngOnInit(): void {
    this.comm.Loc$.subscribe(data=>{ this.Location = data; this.GetStudents()});
     
    
    this.GetStudents();


  }

  GetStudents(){
    if(this.Location.lId !=0){
      this.loading = true;
      this.srv.getStudents(this.Location.lId).subscribe((stu:any) =>{ this.students = stu; this.loading = false;});
    }
    

  }

  viewDetail(stuData:any){

      this.dialog.open(AbsenceDetailModalComponent, {
        data: {
          stu: stuData,
        },
        height: '80%',
        width: '90%',
      });




  }
}
